import React, { Component } from 'react'
import Distributed from './Distributed'
import { OverallInfoContainer } from '../../../containers/POI/Information'
import { Grid } from 'semantic-ui-react'
import "react-table/react-table.css"

class Overall extends Component {
    render() {
        return (
            <Grid className="tap-content" columns={2}>
                <Grid.Column widescreen={3}>
                    <OverallInfoContainer />
                </Grid.Column>
                <Grid.Column widescreen={13}>
                    <Distributed />
                </Grid.Column>
            </Grid>
        )
    }
}
export default Overall
